import React from 'react'

const Networking = () => {
  return (
    <div>
        {/* collapseFourtyTwo */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingFourtyTwo">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourtyTwo" aria-expanded="false" aria-controls="collapseFourtyTwo">
                    {/* You can put your section title here */}
                    Networking
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseFourtyTwo" className="accordion-collapse collapse" aria-labelledby="headingFourtyTwo" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>OSI Layers</li>
                        <li>Protocols</li>
                        <li>TCP</li>
                        <li>IP</li>
                        <li>Ports</li>
                        <li>HTTP/HTTPS</li>
                        <li>CIDR Block</li>
                        <li>IP Table, Route Table</li>
                        <li>Subnet</li>
                        <li>DNS</li>
                        <li>Router, Switch</li>
                        <li>Firewall</li>
                        <li>Public IP / Private IP</li>
                        <li>API Calling</li>
                        <li>Encryption</li>
                        <li>Public & Private Keys</li>
                        <li>CLI - Command Line Tools</li>
                        <li>Curl</li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
  )
}

export default Networking